import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";
import { EXTERIOR_WORLD } from "@catworld/shared";
import { loadBytes, loadJson, urlFor } from "./assets/load.js";

/** Load the visual asset only after confirming it matches the shared physics.
 * @param {import('three').Scene} scene */
export async function loadExterior(scene) {
  const report = /** @type {{sourceSha256:string, exportSha256:string, exportTriangles:number, chunks:number}} */
    (await loadJson("world/exterior.report"));
  if (report.exportSha256 !== EXTERIOR_WORLD.exportSha256) {
    throw new Error("The exterior scene and collision data come from different exports. Rebuild the client.");
  }
  const draco = new DRACOLoader();
  draco.setDecoderPath({ js: urlFor("decoder/draco.js"), wasm: urlFor("decoder/draco.wasm") });
  draco.setWorkerLimit(2);
  try {
    const loader = new GLTFLoader().setDRACOLoader(draco);
    const gltf = await loader.parseAsync(await loadBytes("world/exterior"), "");
    gltf.scene.name = "Glenrose exterior";
    gltf.scene.traverse((object) => {
      if (!("isMesh" in object) || !object.isMesh) return;
      const mesh = /** @type {import('three').Mesh} */ (object);
      mesh.castShadow = !/water|diamond mesh/i.test(mesh.name);
      mesh.receiveShadow = true;
      const materials = Array.isArray(mesh.material) ? mesh.material : [mesh.material];
      for (const material of materials) {
        if ("envMapIntensity" in material) material.envMapIntensity = 0.32;
      }
    });
    scene.add(gltf.scene);
    return report;
  } finally {
    draco.dispose();
  }
}
